<template>
    <el-dialog
        :model-value="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        class="submit-modal"
        width="600px"
        :show-close="false"
        center
        @opened="onModalOpened"
    >
        <template #header="{ close }">
            <div class="custom-header">
                <span class="modal-headline">{{ $trans("web_profile.consent_title") }}</span>
                <span @click="close" class="close-text">
                    {{ $trans("web_profile.cancel") }}
                    <el-icon class="custom-close-icon"><Close /></el-icon>
                </span>
            </div>
        </template>
        <div class="modal-body-content">
            <div class="consent-wrapper">
                <el-checkbox v-model="isConsentGiven" class="consent-checkbox">
                    <span v-html="consentHtml"></span>
                </el-checkbox>
            </div>
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button
                    class="grey-button"
                    @click="$emit('update:modelValue', false)"
                >
                    {{ $trans("web_profile.cancel") }}
                </el-button>
                <el-button
                    class="blue-button"
                    type="primary"
                    @click="handleConfirm"
                    :disabled="!isConsentGiven"
                >
                    {{ $trans("web_profile.submit_modal") }}
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import { Close } from "@element-plus/icons-vue";

export default {
    name: "SubmitWebProfileModal",
    components: {
        Close,
    },
    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
        userGroup: {
            type: String,
            required: true,
        },
        userLang: {
            type: String,
            required: true,
        }
    },
    emits: ["update:modelValue", "confirm"],
    data() {
        return {
            isConsentGiven: false,
        };
    },
    computed: {
        companyLinkInfo() {
            if (this.userGroup === 'si') {
                return {
                    name: 'Swiss Interim',
                    url: 'https://www.swissinterim.com/de',
                    email: 'team@swissinterim.com',
                    color: '#e03a45'
                };
            }
            return {
                name: 'Deutsche Interim',
                url: 'https://www.deutscheinterim.com/de',
                email: 'team@deutscheinterim.com',
                color: '#a99068'
            };
        },
        consentHtml() {
            let text = this.$trans("web_profile.consent_text") || "";
            let link = `<a href="${this.companyLinkInfo.url}" target="_blank" style="color: ${this.companyLinkInfo.color}; text-decoration: none; font-weight: 600;">${this.companyLinkInfo.name}</a>`;
            let emailLink = `<a href="mailto:${this.companyLinkInfo.email}" style="color: ${this.companyLinkInfo.color}; text-decoration: none; font-weight: 600;">${this.companyLinkInfo.email}</a>`;
            
            return text.replace(":company", link).replace(":email", emailLink);
        }
    },
    methods: {
        handleClose() {
            this.$emit("update:modelValue", false);
        },
        handleConfirm() {
            this.$emit("confirm");
            this.handleClose();
        },
        onModalOpened() {
            this.isConsentGiven = false;
        }
    },
    watch: {
        modelValue(newVal) {
            if (!newVal) {
                this.isConsentGiven = false;
            }
        }
    }
};
</script>

<style scoped>
.submit-modal :deep(.el-dialog__header) {
    padding: 20px 25px 15px;
    margin-right: 0;
    border-bottom: none;
}
.submit-modal :deep(.el-dialog__body) {
    padding: 15px 35px 25px;
    color: #3c3c3c;
}
.submit-modal :deep(.el-dialog__footer) {
    border-top: none;
    padding: 15px 25px 25px;
}
:deep(.el-dialog__headerbtn) {
    position: absolute;
    top: 6px;
    right: 0;
    padding: 0;
    width: 88px;
    height: 63px;
    background: 0 0;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: var(--el-message-close-size, 16px);
}
.custom-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    font-size: 18px;
    color: #000;
}
.modal-headline {
    font-size: 20px;
    font-weight: 700;
    color: #3c3c3c;
}
.close-text {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-style: italic;
}
.dialog-footer {
    display: flex;
    gap: 15px;
    width: 100%;
}
.dialog-footer .el-button {
    flex-grow: 1;
    width: 100%;
    font-size: 16px;
    padding: 18px 10px;
    border-radius: 4px;
}
.grey-button {
    background-color: #f2f2f2;
    border-color: #f2f2f2;
    color: #606266;
}
.grey-button:hover,
.grey-button:focus {
    background-color: #e6e6e6;
    border-color: #e6e6e6;
    color: #303133;
}
.blue-button {
    background-color: #41abc4;
    border-color: #41abc4;
    color: white;
}
.blue-button:hover,
.blue-button:focus {
    background-color: #3693a9;
    border-color: #3693a9;
}
.blue-button:disabled {
    background-color: #a0c4cd;
    border-color: #a0c4cd;
    cursor: not-allowed;
}
.modal-body-content {
    font-size: 16px;
    color: #3c3c3c !important;
}
.consent-wrapper {
    margin-top: 15px;
    margin-bottom: 20px;
    display: flex;
    align-items: flex-start;
    text-align: left;
}
.consent-checkbox {
    display: flex !important;
    align-items: flex-start !important;
    width: 100%;
    white-space: normal !important;
    height: auto !important;
}
.consent-checkbox :deep(.el-checkbox__input) {
    transform: scale(1.2);
    margin-right: 12px;
    margin-top: 7px !important;
    flex-shrink: 0;
}
.consent-checkbox :deep(.el-checkbox__label) {
    white-space: normal !important;
    font-size: 17px !important;
    font-weight: 800 !important;
    color: #2c2c2c !important;
    line-height: 1.6 !important;
    letter-spacing: 0.2px;
    padding-left: 0;
    flex: 1;
}
.consent-checkbox :deep(a:hover) {
    text-decoration: underline !important;
    opacity: 0.8;
}
.custom-close-icon {
    font-size: 35px;
    margin-left: 10px;
    vertical-align: middle;
}
</style>